export const messages = {
  en: {
    task: {
      search: {
        title: 'Search Condition',
        taskName: 'taskName',
        templateId: 'templateId',
        taskCron: 'taskCron',
        state: 'state',
        createTime: 'createTime',
        placeholder: 'Please enter task name'
      },
      list: {
        title: 'task List'
      },
      dialog: {
        addTitle: 'Add Task',
        editTitle: 'Edit Task',
        delTitle: 'Delete Task',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        taskId: 'taskId',
        taskName: 'taskName',
        templateId: 'templateId',
        taskCron: 'taskCron',
        state: 'state',
        createTime: 'createTime',
      },
      table: {
        taskId: 'taskId',
        taskName: 'taskName',
        templateId: 'templateId',
        taskCron: 'taskCron',
        state: 'state',
        createTime: 'createTime',
      },
      validate: {
        taskId: 'Please enter taskId',
        taskName: 'Please enter taskName',
        templateId: 'Please enter templateId',
        taskCron: 'Please enter taskCron',
        state: 'Please enter state',
        createTime: 'Please enter createTime',
      },
      add: {
        success: 'Add Task success'
      },
      edit: {
        success: 'Edit Task success'
      },
      delete: {
        success: 'Delete Task success',
        confirm: 'Are you sure to delete this task?'
      },
      fetchError: 'Failed to fetch task list',
      start: 'start',
      stop: 'stop',
      timeout: 'Submitted task, please check the result later',
      logBtn: 'Log',
      logTitle: 'Task Log',
      log: {
        startTime: 'Start Time',
        endTime: 'End Time',
        duration: 'Duration',
        state: 'State',
        success: 'Success',
        fail: 'Fail',
        result: 'Result',
        fetchError: 'Failed to fetch task logs'
      }
    }
  },
  zh: {
    task: {
      search: {
        title: '查询条件',
        taskName: '任务名称',
        templateId: '模版名称',
        taskCron: '运行时间',
        state: '启停状态',
        createTime: '创建时间',
        placeholder: '请输入定时任务名称'
      },
      list: {
        title: '定时任务'
      },
      dialog: {
        addTitle: '添加定时任务',
        editTitle: '编辑定时任务',
        delTitle: '删除定时任务',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        taskId: '任务ID',
        taskName: '任务名称',
        templateId: '模版名称',
        taskCron: '运行时间',
        state: '启停状态',
        createTime: '创建时间',
      },
      table: {
        taskId: '任务ID',
        taskName: '任务名称',
        templateId: '模版名称',
        taskCron: '运行时间',
        state: '启停状态',
        createTime: '创建时间',
      },
      validate: {
        taskId: '请输入任务ID',
        taskName: '请输入任务名称',
        templateId: '请输入模版名称',
        taskCron: '请输入运行时间',
        state: '请输入启停状态',
        createTime: '请输入创建时间',
      },
      add: {
        success: '添加定时任务成功'
      },
      edit: {
        success: '编辑定时任务成功'
      },
      delete: {
        success: '删除定时任务成功',
        confirm: '确认删除该定时任务吗？'
      },
      fetchError: '获取定时任务列表失败',
      start: '启动',
      stop: '停止',
      timeout: '已提交任务，请稍后查看结果',
      logBtn: '日志',
      logTitle: '任务日志',
      log: {
        startTime: '开始时间',
        endTime: '结束时间',
        duration: '耗时',
        state: '状态',
        success: '成功',
        fail: '失败',
        result: '结果/错误',
        fetchError: '获取任务日志失败'
      }
    }
  }
}